<template>
    <div class="productClassInfo">
        <div class="left">
            <div class="img">
                <img width="100%" :src="ip+'/image_product/产品大类/'+classData.imgName+'.jpg'" alt="" srcset="">
            </div>
        </div>
        <div class="right">
            <div class="title">{{name}}</div>
            <div class="line"></div>
            
            <div class="box">
                <div class="text" v-if="classData.class_text_type==1" v-for="(item, index) in text" :key="index">
                    <div class="text_title">{{item.name}}: </div>
                    <div class="text_content">{{item.txt}}</div>                
                </div>
                <div class="text" v-if="classData.class_text_type==0" v-html="text"></div>
                <div class="bottom">
                    <div class="imgList">
                        <div class="img_box" v-for="(item, index) in productList" :key="index" @click="toProductInfo(index)">
                            <img :src="ip+'/image_product/产品详情/'+item.img" width="100%" height="100%" alt="" srcset="">
                        </div>                                                     
                    </div>
                    <div class="btn_box">
                        <div class="btn" @click="toEmail()">
                            <div class="img" style="transform: translate(50%,-50%);left: 0;top: 50%;"></div>
                            E-mail
                        </div>
                        <div class="btn" @click="mores()">
                            {{$t('详细了解')}}
                            <div class="img"  style="transform: translate(-50%,-50%);right: 0;top: 50%;"></div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    props:['classData'],
    data() {
        return {
            productList:[]
        }
    },
    created(){
        let classId = this.classData.id
        let _this = this
        this.$axios({
            method:'post',
            url:this.ip + '/getProductList',
            data:this.qs.stringify({
                classId:classId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            _this.productList = response.data.data
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
            alert(error)
        })
    },
    methods:{
        toProductInfo(i){
            this.$router.push({
                path:"/productClass_info",//这个path就是你在router/index.js里边配置的路径
                query:{
                    productId:this.productList[i].productId,
                    classId:this.productList[i].classId,
                }
            })
        },
        mores(){
            if(this.productList.length>1){
                this.$router.push('/productClass_info_class?classId=' + this.classData.id)
            }else{
                this.$router.push(`/productClass_info?productId=${this.productList[0].productId}&classId=${this.productList[0].classId}`)
            }
        },
        toEmail(){
            this.$router.push('/contact?type=Email')
        }
    },
    computed:{
        text(){
            if(this.classData.class_text_type==1){
                return this.$i18n.locale=='zh'? JSON.parse(this.classData.class_text_zh):JSON.parse(this.classData.class_text_en)
            }else if(this.classData.class_text_type==0){
                return this.$i18n.locale=='zh'?this.classData.class_text_zh:this.classData.class_text_en
            }
        },
        name(){
            return this.$i18n.locale=='zh'?this.classData.name_zh:this.classData.name_en
        }
    }
}
</script>
<style lang="less" scoped>
@width:55vw;
@height: @width/3.14;
@import url('../assets/font.css');
.productClassInfo{
    width: @width;
    min-height:@height;
    // background-color: red;   
    display: flex;
    margin-bottom: 25px;
    justify-content: space-between;
    .left{
        width: @height*1.06;
        // height: @height;
        background-color: #F5F5F5;
        display: flex;
        align-items: center;
        justify-content: center;
        .img{
            width: 92%;
            margin-top: 10px;
            // height: 92%;
            // background-color: aquamarine;
        }
    }
    .btn_box{
        display: flex;
        .btn{
            margin-right: 30px;
            font-family: 'YHBD';
            color: #ffffff;
            width: 10vw;
            text-align: center;
            font-size: 0.8vw;
            height: 1.8vw;
            background-image: linear-gradient(45deg,#009D40,#007CA9);
            display: flex;
            align-items: center;
            position: relative;
            justify-content: center;
            cursor: pointer;
            .img{
                position: absolute;
                width: 1.8vw;
                height: 1.1vw;
                // margin: 0px 10px;
                // background-color: red;

                
            }
        }
    }
    .box{
        // background-color: red;
        min-height: @height - 4vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .bottom{
        margin-bottom: 10px;
        width: calc((@width - @height*1.06) - 30px);
        height: fit-content;
        margin-top: 10px;
        // position: absolute;
        // left: 0;
        // bottom: 0;
        .imgList{
            width: 100%;
            height: fit-content;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 10px;
            .img_box{
                width: 10%;
                height: 3.5vw;
                margin-left: 1%;
                margin-bottom: 0.5vw;   
                border: 1px solid #007DA7;       
            }
        }
    }
    .right{
        width: calc((@width - @height*1.06) - 30px);
        min-height: @height;
        background-color: #ffffff;
        position: relative;
        .title{
            // font-size: 20px;
            letter-spacing: 3px;
            color: #444444;
            font-family: 'YHBD';
            font-weight: bold;
            line-height: 30px;
            font-size: 1.3vw;
            line-height: 3vw;
        }
        .line{
            background-color: #444444;
            height: 2px;
            width: 100%;
            margin-bottom: 10px;
            transform: scaleY(0.3);
        }
        .text{
            color: #5E5E5E;
            width: 100%;
            font-weight: bold;
            height: fit-content;
            display: flex;
            // font-weight: bold;
            // font-family: "YHBD";
            line-height: 160%;
            // letter-spacing: 3px;
            // line-height: 1.6vw;
            // background-color: red;
            // font-size: 0.6vw;
            font-size: 12px;
            .text_title{
                width: fit-content;
                white-space:nowrap;
                // font-family: "YH";
                // font-family: 'pf';                
            }
            .text_content{
                // font-family: "YH";                
                font-family: 'pf';
            }
        }
    }
}
</style>

